"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillMode = exports.Fill = void 0;
var Fill;
(function (Fill) {
    Fill["Site"] = "u-fill-site";
    Fill["SiteImportant"] = "u-fill-site!";
    Fill["Dark"] = "u-fill-dark";
    Fill["Text"] = "u-fill-text";
    Fill["Link"] = "u-fill-link";
    Fill["One"] = "u-fill-1";
    Fill["Two"] = "u-fill-2";
    Fill["Three"] = "u-fill-3";
    Fill["Positive"] = "u-fill-pos";
    Fill["Negative"] = "u-fill-negative";
    Fill["Warning"] = "u-fill-warn";
    Fill["Black"] = "u-fill-black";
    Fill["BlackImportant"] = "u-fill-black!";
    Fill["White"] = "u-fill-white";
    Fill["WhiteImportant"] = "u-fill-white!";
    Fill["Shade"] = "u-fill-shade";
    Fill["ShadeImportant"] = "u-fill-shade!";
    Fill["Tint"] = "u-fill-tint";
    Fill["TintImportant"] = "u-fill-tint!";
    Fill["TintDark"] = "u-fill-tint@dark";
    Fill["Fade"] = "u-fill-fade";
    Fill["OnlyDark"] = "u-fill-only-dark";
    Fill["OnlyText"] = "u-fill-only-text";
    Fill["OnlyLink"] = "u-fill-only-link";
    Fill["OnlyOne"] = "u-fill-only-1";
    Fill["OnlyTwo"] = "u-fill-only-2";
    Fill["OnlyThree"] = "u-fill-only-3";
    Fill["OnlyPositive"] = "u-fill-only-positive";
    Fill["OnlyNegative"] = "u-fill-only-negative";
    Fill["OnlyWarning"] = "u-fill-only-warning";
})(Fill = exports.Fill || (exports.Fill = {}));
var FillMode;
(function (FillMode) {
    FillMode["None"] = "u-fill-mode-none";
    FillMode["Both"] = "u-fill-mode-both";
    FillMode["Forwards"] = "u-fill-mode-forwards";
    FillMode["Backwards"] = "u-fill-mode-backwards";
})(FillMode = exports.FillMode || (exports.FillMode = {}));
//# sourceMappingURL=Fill.js.map